import { spMode } from "@/hooks";
import { color, Font } from "@moneyforward/mfx_biz_react_components";
import { createContext, ReactNode, useContext } from "react";

interface ExternalServiceDef {
  icon: ReactNode;
  nameJaJp: string;
  description: string;
  note?: string | React.ReactNode;
  info?: React.ReactNode;
  link: string;
}

const ServiceButtonExternalContext = createContext("");

export const ServiceButtonExternal = ({
  service,
  suspended = false,
  displayCompanyID,
}: {
  service: ExternalServiceDef;
  suspended: boolean;
  displayCompanyID: string;
}) => {
  return (
    <ServiceButtonExternalContext.Provider value={displayCompanyID}>
      <div
        css={{
          display: "flex",
          flexDirection: "row",
          gap: "24px",
          position: "relative",
          width: "312px",
          [spMode]: {
            flexDirection: "column",
            width: "100%",
          },
        }}
      >
        <a
          href={service.link}
          target="_blank"
          rel="noopener noreferrer"
          css={{
            textAlign: "center",
            alignItems: "center",
            padding: "8px 16px",
            border: `1px solid ${color.gray300}`,
            borderRadius: "4px",
            ":hover": {
              cursor: "pointer",
              backgroundColor: color.gray50,
            },
            width: "100%",
            display: "flex",
            flexDirection: "row",
            gap: "16px",
          }}
        >
          <div
            css={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "40px",
              height: "40px",
            }}
          >
            {service.icon}
          </div>
          <div
            css={{
              textAlign: "left",
              display: "flex",
              flexDirection: "column",
              minHeight: "96px",
              justifyContent: "center",
              whiteSpace: "pre-wrap",
            }}
          >
            <Font variant="mb">{service.nameJaJp}</Font>
            <Font variant="m">{service.info}</Font>
            <Font variant="s">{service.description}</Font>
            <Font variant="s">{service?.note || null}</Font>
          </div>
        </a>
        {suspended && (
          <div
            css={{
              position: "absolute",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              width: "100%",
              backgroundColor: color.gray100,
              opacity: 0.9,
              zIndex: 2,
              color: color.gray600,
            }}
          >
            <Font variant="lb">利用停止中</Font>
          </div>
        )}
      </div>
    </ServiceButtonExternalContext.Provider>
  );
};

export const ServiceButtonExternalDisplayCompanyID = () => {
  const displayCompanyID = useContext(ServiceButtonExternalContext);
  return <div>{displayCompanyID}</div>;
};
